define([
    'edge/platform/featuredetection/ApplicationFeatures',
    'edge/quoteandbind/common/config/FlowConfig',
    'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/pa/config/FlowConfig',
    'conditional?if=quoteandbind_lob&equals=ho!edge/quoteandbind/ho/config/FlowConfig',
    'conditional?if=quoteandbind_lob&equals=cp!edge/quoteandbind/cp/config/FlowConfig'
], (ApplicationFeatures, commonSubFlowDefnFactories, paFlowDefnFactory, hoFlowDefnFactory, cpFlowDefnFactory)=> {
    return function (flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService) {

        /**
         * Convert object containing flow definitions into object containing sub flows
         * @param subFlowDefns Object containing flow definitions
         */
        function createSubFlowsFromFlowDefns(subFlowDefns) {
            const subFlowsContainer = {};
            Object.keys(subFlowDefns).reduce((container, flowDefnKey) => {
                container[flowDefnKey] = flow(subFlowDefns[flowDefnKey]);
                return container;
            }, subFlowsContainer);
            return subFlowsContainer;
        }

        const commonSubFlowDefns = commonSubFlowDefnFactories(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService);

        const globalExits = flow(commonSubFlowDefns.globalExits);
        const availabilityFlow = flow(commonSubFlowDefns.availabilityCheck);
        const needToSaveCheckFlow = flow(commonSubFlowDefns.needToSaveCheck);
        let paFlows;
        let hoFlows;
        let cpFlows;
        //if the personal auto feature is enabled then create the PA flow
        if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
            const paFlowDefns = paFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
            paFlows = createSubFlowsFromFlowDefns(paFlowDefns);
        }
        //if the homeowners feature is enabled then create the HO flow
        if (ApplicationFeatures.hasFeature('quoteandbind_lob.ho')) {
            const hoFlowDefns = hoFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService);
            hoFlows = createSubFlowsFromFlowDefns(hoFlowDefns);
        }
        //if the commercial property feature is enabled then create the CP flow
        if (ApplicationFeatures.hasFeature('quoteandbind_lob.cp')) {
            const cpFlowDefns = cpFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
            cpFlows = createSubFlowsFromFlowDefns(cpFlowDefns);
        }
        const quoteFlow = flow(commonSubFlowDefns.quote);
        const bindFlow = flow(commonSubFlowDefns.bindAndPay);

        return {
            exit: globalExits,
            availability: availabilityFlow,
            needToSaveCheck: needToSaveCheckFlow,
            paFlows: paFlows,
            hoFlows: hoFlows,
            cpFlows: cpFlows,
            quote: quoteFlow,
            bind: bindFlow
        };
    };
});



/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/config/_createSubflowsFromDefns.js
 **/